import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { WebService } from "../services/web/web.service";

@Injectable({
  providedIn: "root",
})
export class RbacService {
  private readonly appName = "onboarding";

  constructor(private webService: WebService) {}

  listRoles(partnerId: number, roleName?: string, roleId?: number | string): Observable<any> {
    let params = new HttpParams()
      .set("pageIndex", "-1")
      .set("pageSize", "-1")
      .set("aplicativo", this.appName);

    if (roleName) {
      params = params.set("roleName", roleName);
    }
    if (roleId) {
      params = params.set("roleId", roleId.toString());
    }

    return this.webService.get(this.roleBaseUrl(partnerId), params);
  }

  getRole(partnerId: number, roleId: number | string): Observable<any> {
    return this.listRoles(partnerId, undefined, roleId);
  }

  listUsers(partnerId: number, params = new HttpParams()): Observable<any> {
    return this.webService.get(
      `${this.webService.HOST}/functional_security/partner/${partnerId}/users/onboarding-admin`,
      params
    );
  }

  createOnboardingUser(body: {
    partnerId: number;
    name_user: string;
    lastName_user: string;
    email_user: string;
    password: string;
  }): Observable<any> {
    return this.webService.post(body, `${this.webService.HOST}/api/users/onboarding-admin`);
  }

  resendOnboardingUserInvitation(partnerId: number, userId: number | string): Observable<any> {
    return this.webService.post(
      { partnerId },
      `${this.webService.HOST}/api/users/onboarding-admin/${userId}/resend-welcome-email`
    );
  }

  deactivateUser(partnerId: number, userId: number | string): Observable<any> {
    return this.webService.patch(
      {},
      `${this.webService.HOST}/functional_security/partner/${partnerId}/user/${userId}/deactivate`
    );
  }

  reactivateOnboardingUser(partnerId: number, user: any): Observable<any> {
    const body = {
      partnerId,
      name_user: user.name_user,
      lastName_user: user.lastName_user,
      email_user: user.email_user,
      status_user: 1,
    };

    return this.webService.put(body, `${this.webService.HOST}/api/users/onboarding-admin/${user.id}`);
  }

  listMenus(params = new HttpParams()): Observable<any> {
    const requestParams = params
      .set("pageIndex", params.get("pageIndex") || "-1")
      .set("pageSize", params.get("pageSize") || "-1")
      .set("aplicativo", params.get("aplicativo") || this.appName);

    return this.webService.get(
      `${this.webService.HOST}/functional_security/partner/menus`,
      requestParams
    );
  }

  createRole(partnerId: number, body: { name: string; description?: string }): Observable<any> {
    return this.webService.post(body, this.roleBaseUrl(partnerId));
  }

  updateRole(partnerId: number, roleId: number | string, body: { name: string; description?: string }): Observable<any> {
    return this.webService.put(body, `${this.roleBaseUrl(partnerId)}/${roleId}`);
  }

  deleteRole(partnerId: number, roleId: number | string): Observable<any> {
    return this.webService.delete({}, `${this.roleBaseUrl(partnerId)}/${roleId}`);
  }

  addPermissions(partnerId: number, roleId: number | string, permissionIds: number[]): Observable<any> {
    return this.webService.post(
      { permissionIds },
      `${this.roleBaseUrl(partnerId)}/${roleId}/permissions/add`
    );
  }

  removePermissions(partnerId: number, roleId: number | string, permissionIds: number[]): Observable<any> {
    console.log("Removing permissions:", permissionIds);
    return this.webService.post(
      { permissionIds },
      `${this.roleBaseUrl(partnerId)}/${roleId}/permissions/remove`
    );
  }

  addRoleToUser(partnerId: number, userId: number | string, roleId: number | string): Observable<any> {
    return this.webService.post(
      { roleId },
      `${this.webService.HOST}/functional_security/partner/${partnerId}/user/${userId}/roles/add`
    );
  }

  removeRoleFromUser(partnerId: number, userId: number | string, roleId: number | string): Observable<any> {
    return this.webService.post(
      { roleId },
      `${this.webService.HOST}/functional_security/partner/${partnerId}/user/${userId}/roles/remove`
    );
  }

  getUserPermissions(partnerId: number, userId: number | string): Observable<any> {
    const params = new HttpParams().set("aplicativo", this.appName);
    return this.webService.get(
      `${this.webService.HOST}/functional_security/partner/${partnerId}/user/${userId}/permissions`,
      params
    );
  }

  private roleBaseUrl(partnerId: number): string {
    return `${this.webService.HOST}/functional_security/partner/${partnerId}/role`;
  }
}
